import * as React from 'react';
import { Field } from 'redux-form';
import {
  FormStyled,
  Link,
  SubTitle,
  Text,
  LinkWrapper
} from '../Form/styled';

import { Button } from '@app/src/components/Button';
import { Icon } from '@app/src/components/Icon';

import { RenderInput } from '@app/src/views/Login/RenderInput';
import { required, email } from '@app/src/utils/validations';
import { ModalContainer } from '../Modal';

export const Form = ({
  handleSubmit,
  handleClick,
  isFetching,
  reset,
  code,
  errorMessage,
  userMail
}) => (
  <FormStyled data-test="passwordForm" onSubmit={handleSubmit} >
    <SubTitle data-test="title">Restablecer contraseña</SubTitle>
    <Text>Introduce la dirección de correo electrónico asociada a tu cuenta y te enviaremos un enlace para cambiar tu contraseña.</Text>
    <Field
      name="email"
      type="text"
      maxLength="120"
      label="Dirección de correo electrónico"
      component={RenderInput}
      validate={[required, email]}
    />
    <Button data-test="btnRecover" type="submit" primary fullWidth loading={isFetching}>Restablecer contraseña</Button>
    <LinkWrapper>
      <Icon name="chevron-left" color="black" size="36px" />
      <Link data-test="loginReturn" onClick={handleClick} >Volver al inicio de sesión</Link>
    </LinkWrapper>
    <ModalContainer data-test="modal" reset={reset} code={code} email={userMail} errorMessage={errorMessage} />
  </FormStyled>
);
